import React from 'react';
import ReturnsIcon from '@moda/icons/returns-16';
import { ReturnPolicy } from '../../generated/types/globalTypes';

interface Props {
  returnPolicy: ReturnPolicy;
}

export const ReturnPolicyIcon: React.FC<Props> = ({ returnPolicy }) => {
  if (returnPolicy === ReturnPolicy.final_sale) return null;

  return <ReturnsIcon className="ReturnPolicyIcon" />;
};
